import { render, staticRenderFns } from "./CopyIp.vue?vue&type=template&id=29dab774&scoped=true"
import script from "./CopyIp.vue?vue&type=script&lang=js"
export * from "./CopyIp.vue?vue&type=script&lang=js"
import style0 from "./CopyIp.vue?vue&type=style&index=0&id=29dab774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dab774",
  null
  
)

export default component.exports